import { useState } from "react";
import "./App.css";
import './index.css'
import HomePage from "./HomePage/HomePage";
import Register from "./LoginRegister/Register/Register";
import Footer from "./SidebarHeader/Footer/Footer";
import Header from "./SidebarHeader/Header/Header";
import Sidebar from "./SidebarHeader/Sidebar/Sidebar";
import { Route, Routes, useNavigate } from "react-router-dom";
import MyProfile from "./HomePage/Profile/MyProfile";
import TimeTable from "./DCM/components/Time-table";
import { Navigate } from "react-router-dom";
import HomeWorkMain from "./HwManagement/HomeWork/HomeWorkMain";
import ActivityMain from "./HwManagement/Activity/ActivityMain";
import PreReadMain from "./HwManagement/PreRead/PreReadMain";
import SummaryMain from "./DcmDetails/Summary/SummaryMain";
import LiveMain from "./DcmDetails/Live/LiveMain";
import AssesmentMain from "./DcmDetails/Assesment/AssesmentMain";
import LibraryMain from "./HomePage/Library/LibraryMain";
import GroupWiseQuery from "./Engagement/StudentQuery/Group_Wise_Query/GroupWiseQuery";
import { useSelector } from "react-redux";
import PendingSubDetails from "./HwManagement/PreRead/Pending/PendingSubDetails";
import CompletedSubDetails from "./HwManagement/PreRead/Completed/CompletedSubDetails";
import QueryEngagement from "./Engagement/Query/QueryEngagement";
import EngagementCommunity from "./Engagement/Community/EngagementCommunity";
import GroupDetails from "./Engagement/Community/GroupDetails";
import FeedDetail from "./Engagement/Open_community/Feed_Detail/FeedDetail";
import TotalCommuPost from "./Engagement/Open_community/total_community_post/TotalCommuPost";
import ViewFirstScreen from "./Engagement/Create_channel/View_Channel_Screen/View_First_Screen/ViewFirstScreen";
import CreateCommunity from "./Engagement/Create_channel/Create/Create";
import AllQuestions1 from "./DcmDetails/Assesment/Pending/QuestionTypes/AllQuestions";
import AllQuestions2 from "./DcmDetails/Assesment/Onreview/QuestionTypes/AllQuestions";
import AllQuestions3 from "./DcmDetails/Assesment/Completed/QuestionCompleted/AllQuestions";

import LibrarySubjectDetail from "./HomePage/Library/LibraySubjectDatail/LibrarySubjectDetail";
import LibraryChapterDetails from "./HomePage/Library/LibraySubjectDatail/LibraryChapter/LibraryChapterDetails";
import { useEffect } from "react";
import RegisterSuccess from "./LoginRegister/Register/RegisterSuccess";
import LoginSuccess from "./LoginRegister/Register/LoginSuccess";
import HeaderContext from "./HeaderContext";
import UnRegSuccess from "./LoginRegister/Register/UnRegSuccess";
import AllQuestions from "./HwManagement/HomeWork/Pending/QuestionTypes/AllQuestions";
import AllQuestions4 from "./HwManagement/HomeWork/Completed/QuestionCompleted/AllQuestions";
import AllQuestions5 from "./HwManagement/HomeWork/OnReview/QuestionTypes/AllQuestions";
import ActivityPendingSubjDetail from "./HwManagement/Activity/Pending/ActivityPendingSubjDetail";
import ActivityOnReviewSubDetail from "./HwManagement/Activity/OnReview/ActivityOnReviewSubDetail";
import ActivityCompletedSubDetail from "./HwManagement/Activity/Completed/ActivityCompletedSubDetail";
import ResetSuccess from "./LoginRegister/Register/ResetSuccess";
// import SummaryUpdated from "./DcmDetails/Summary/SummaryUpdated/SummaryUpdated";
import TicketsMain from "./Ticket";
import SelfAssessment from "./DcmDetails/SelfAssessment/SelfAssessment";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import TicketPopup from "./Ticket/TicketPopup";
import SummaryUpdated from "./DCM/components/SummaryUpdated/SummaryUpdated";
import AdaptiveAss from "./DcmDetails/Assesment/Pending/AdaptiveAss";
import CompletedAdaptiveQues from "./DcmDetails/Assesment/Completed/CompletedAdaptiveQues";
import StudentAttendance from "./Student_attendance/StudentAttendance";
import ViewReport from "./Student_attendance/View_report/ViewReport";
import TakeAttendance from "./Student_attendance/Take_attendance/TakeAttendance";


let classTeachers = []
let coOrdinators = []
function App() {
  const storedSetLogin = useSelector((state) => state.user.currentUser);
  let studentDetail = JSON.parse(localStorage.getItem("breathForStudent"));
  const [countComment, setCommentCount] = useState(0);
  const [footer, setFooter] = useState({
    footerMenu: "Home",
    myProfile: false,
    ticket: false,
    setIsLoggedIn: false,
  });

  const handleProfile = () => {
    setFooter({
      ...footer,
      myProfile: true,
    });
  };
  const navigate = useNavigate();

  const handleTicket = () => {
    setFooter({
      ...footer,
      ticket: true,
    });
  };

  const handleProfileClose = () => {
    setFooter({
      ...footer,
      myProfile: false,
    });
  };

  const handleTicketClose = () => {
    setFooter({
      ...footer,
      ticket: false,
    });
  };

  useEffect(() => {
    getAllClassTeachers()
    getAllCoOrdinators()
  }, [])

  function getAllClassTeachers() {
    studentDetail?.teacher_information?.forEach(element => {
      if (element.is_class_teacher === true) {
        const teachers = element.teacher.name;
        classTeachers.push(teachers)
      }
    });
  }
  function getAllCoOrdinators() {
    studentDetail?.teacher_information?.forEach(element => {
      if (element.is_Co_Ordinator === true) {
        const co_ordinator = element.teacher.name;
        coOrdinators.push(co_ordinator)
      }
    });
  }

  // const [isLoggedIn, setIsLoggedIn] = useState(false);

  // fro sidemenu active
  const [sidebarMenu, setSideBarMenu] = useState({
    activeMenu: "Dashboard",
    activeMenuHW: "Homework",
    activeMenuSummary: "Summary",
    activeMenuEngage: "Comunity",
  });

  const changeActiveMenuHome = (newActiveMenu) => {
    setSideBarMenu({ ...sidebarMenu, activeMenu: newActiveMenu });
    localStorage.setItem("homeSideMenu", newActiveMenu);
  };

  const changeActiveMenuHw = (newActiveMenu) => {
    setSideBarMenu({ ...sidebarMenu, activeMenuHW: newActiveMenu });
    localStorage.setItem("hwSideMenu", newActiveMenu);
  };
  const changeActiveMenuSummary = (newActiveMenu) => {
    setSideBarMenu({ ...sidebarMenu, activeMenuSummary: newActiveMenu });
    localStorage.setItem("summarySideMenu", newActiveMenu);
  };

  const changeActiveMenuEngage = (newActiveMenu) => {
    setSideBarMenu({ ...sidebarMenu, activeMenuEngage: newActiveMenu });
    localStorage.setItem("engageSideMenu", newActiveMenu);
  };
  const [studentData, setStudentData] = useState("");
  useEffect(() => {
    let studentId = JSON.parse(localStorage.getItem("breathForStudent"));
    setStudentData(studentId);
  }, []);
  return (<>
    <ToastContainer
      style={{ zIndex: 999999 }}
      position="top-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
    />

    <HeaderContext.Provider value={{ handleProfile, handleTicket, countComment, setCommentCount }}>

      <div className="StudentContainer">
        <div className="MainSidebarContainer">
          <Sidebar
            footer={footer.footerMenu}
            sidebarMenuHome={sidebarMenu.activeMenu}
            changeActiveMenuHome={changeActiveMenuHome}
            changeActiveMenuHw={changeActiveMenuHw}
            sidebarMenuW={sidebarMenu.activeMenuHW}
            changeActiveMenuSummary={changeActiveMenuSummary}
            sidebarMenuSummary={sidebarMenu.activeMenuSummary}
            changeActiveMenuEngage={changeActiveMenuEngage}
            sidebarMenuEnggage={sidebarMenu.activeMenuEngage}
          />
        </div>

        {footer.ticket && (
          <TicketPopup handleTicketClose={handleTicketClose} />
        )}


        {footer.myProfile && (
          <MyProfile handleProfileClose={handleProfileClose} classTeachers={classTeachers} coOrdinators={coOrdinators} />
        )}

        {!footer.myProfile && !footer.ticket && (
          <div className="Container_header_footer">
            <div className="MainHeaderContainer mt-2">
              <Header
                handleProfile={handleProfile}
                handleTicket={handleTicket}
                sidebarMenuW={sidebarMenu.activeMenuHW}
              />
            </div>

            <div className="HomePage px-3 py-1">
              <Routes>
                <Route
                  exact
                  path="/"
                  element={<Register setFooter={setFooter} footer={footer} />}
                />
                <Route
                  exact
                  path="/HomePage"
                  element={
                    storedSetLogin ? (
                      <HomePage data={studentData} />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  exact
                  path="/Calender"
                  element={storedSetLogin ? <TimeTable /> : <Navigate to="/" />}
                />
                <Route
                  exact
                  path="/Library"
                  element={
                    storedSetLogin ? <LibraryMain /> : <Navigate to="/" />
                  }
                />
                <Route
                  exact
                  path="/Library/SubjectDetails"
                  element={
                    storedSetLogin ? (
                      <LibrarySubjectDetail />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  exact
                  path="/Library/ChapterDetails/:index/:isContinue"
                  element={
                    storedSetLogin ? (
                      <LibraryChapterDetails />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  exact
                  path="/Homework"
                  element={
                    storedSetLogin ? <HomeWorkMain type="Homework" /> : <Navigate to="/" />
                  }
                />
                <Route
                  exact
                  path="/Summaryupdate"
                  element={
                    storedSetLogin ? <SummaryUpdated /> : <Navigate to="/" />
                  }
                />
                <Route
                  exact
                  path="/publishedHomework"
                  element={
                    storedSetLogin ? <AllQuestions type="HW" /> : <Navigate to="/" />
                  }
                />
                <Route
                  exact
                  path="/reviewHomework"
                  element={
                    storedSetLogin ? <AllQuestions5 /> : <Navigate to="/" />
                  }
                />
                <Route
                  exact
                  path="/completedHomework"
                  element={
                    storedSetLogin ? <AllQuestions4 type="HW" /> : <Navigate to="/" />
                  }
                />
                <Route
                  exact
                  path="/PreRead"
                  element={
                    storedSetLogin ? <PreReadMain type="Pre-read" /> : <Navigate to="/" />
                  }
                />
                <Route
                  exact
                  path="/preReads/published"
                  element={
                    storedSetLogin ? <PendingSubDetails /> : <Navigate to="/" />
                  }
                />
                <Route
                  exact
                  path="/presRead/completed"
                  element={
                    storedSetLogin ? (
                      <CompletedSubDetails />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route path="/feedDetail" element={<FeedDetail />} />
                <Route
                  path="/EngagementCommunity"
                  element={<TotalCommuPost />}
                />
                <Route
                  path="/viewFirstScreen"
                  element={<ViewFirstScreen />}
                />
                <Route
                  exact
                  path="/CreateCommunity"
                  element={<CreateCommunity />}
                />
                <Route
                  exact
                  path="/Activity"
                  element={
                    storedSetLogin ? <ActivityMain type="Activity" /> : <Navigate to="/" />
                  }
                />
                <Route
                  exact
                  path="/publishedActivity"
                  element={
                    storedSetLogin ? (
                      <ActivityPendingSubjDetail />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  exact
                  path="/reviewActivity"
                  element={
                    storedSetLogin ? (
                      <ActivityOnReviewSubDetail />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  exact
                  path="/completedActivity"
                  element={
                    storedSetLogin ? (
                      <ActivityCompletedSubDetail />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  exact
                  path="/publishedActivity"
                  element={
                    storedSetLogin ? <ActivityMain /> : <Navigate to="/" />
                  }
                />
                <Route
                  exact
                  path="/Summary"
                  element={
                    storedSetLogin ? <SummaryMain /> : <Navigate to="/" />
                  }
                />
                <Route
                  exact
                  path="/Live"
                  element={storedSetLogin ? <LiveMain /> : <Navigate to="/" />}
                />
                <Route
                  exact
                  path="/Assessment"
                  element={
                    storedSetLogin ? <AssesmentMain /> : <Navigate to="/" />
                  }
                />
                {/* Need to check */}
                <Route
                  exact
                  path="/Assessment/completed"
                  element={
                    storedSetLogin ? <AllQuestions3 /> : <Navigate to="/" />
                  }
                />
                <Route
                  exact
                  path="/Assessment/adaptivequestion"
                  element={
                    storedSetLogin ? <AdaptiveAss /> : <Navigate to="/" />
                  }
                />
                <Route
                  exact
                  path="/Assessment/adaptivequestion/completed"
                  element={
                    storedSetLogin ? <CompletedAdaptiveQues /> : <Navigate to="/" />
                  }
                />
                {/* Need to check */}
                <Route
                  path="/Assessment/pending/questions/:assessmentId"
                  element={
                    storedSetLogin ? <AllQuestions1 /> : <Navigate to="/" />
                  }
                />
                <Route
                  exact
                  path="/SelfAssessment"
                  element={
                    storedSetLogin ? <SelfAssessment type="Self-Assessment" /> : <Navigate to="/" />
                  }
                />
                <Route
                  exact
                  path="/publishedSelfAssessment"
                  element={
                    storedSetLogin ? <AllQuestions type="SA" /> : <Navigate to="/" />
                  }
                />
                <Route
                  exact
                  path="/completedSelfAssessment"
                  element={
                    storedSetLogin ? <AllQuestions4 type="SA" /> : <Navigate to="/" />
                  }
                />
                <Route
                  exact
                  path="/retestSelfAssessment"
                  element={
                    storedSetLogin ? <AllQuestions2 type="SA" /> : <Navigate to="/" />
                  }
                />
                <Route path="/regSuccess" element={<RegisterSuccess />} />
                <Route path="/loginSuccessful" element={<LoginSuccess />} />
                <Route path="/resetSuccessful" element={<ResetSuccess />} />
                <Route path="/unRegSuccessful" element={<UnRegSuccess />} />
                <Route
                  path="/Assessment/review/questions"
                  element={
                    storedSetLogin ? <AllQuestions2 /> : <Navigate to="/" />
                  }
                />
                <Route
                  exact
                  path="/EngagementQuery"
                  element={
                    storedSetLogin ? <QueryEngagement /> : <Navigate to="/" />
                  }
                />
                <Route
                  path="/groupWiseQuery"
                  element={<GroupWiseQuery />}
                />
                <Route
                  exact
                  path="/EngagementCommunity"
                  element={
                    storedSetLogin ? (
                      <EngagementCommunity />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  exact
                  path="/GroupDetailsCommunity"
                  element={
                    storedSetLogin ? <GroupDetails /> : <Navigate to="/" />
                  }
                />
                <Route
                  exact
                  path="/ticketMain"
                  element={
                    storedSetLogin ? <TicketsMain /> : <Navigate to="/" />
                  }
                />
                <Route
                  exact
                  path="/student-attendance"
                  element={
                    storedSetLogin ? <StudentAttendance /> : <Navigate to="/" />
                  }
                />
                <Route
                  exact
                  path="/view-report"
                  element={
                    storedSetLogin ? <ViewReport /> : <Navigate to="/" />
                  }
                />
                <Route
                  exact
                  path="/take-attendance"
                  element={
                    storedSetLogin ? <TakeAttendance /> : <Navigate to="/" />
                  }
                />
                <Route path="*" element={<Navigate to="/" />} />
              </Routes>
            </div>

            <div className="MainFooterContainer ">
              <Footer
                setFooter={setFooter}
                footer={footer.footerMenu}
                changeActiveMenuHome={changeActiveMenuHome}
                changeActiveMenuHw={changeActiveMenuHw}
                changeActiveMenuSummary={changeActiveMenuSummary}
                changeActiveMenuEngage={changeActiveMenuEngage}
              />
            </div>
          </div>
        )}
      </div>
    </HeaderContext.Provider>
  </>
  );
}

export default App;
